import { moduleFactory } from "@/factories/module";
import { parseUnknownErrorIntoBaseError } from "@/modules/error-handling/parseUnknownErrorIntoBaseError";

export const errorHandlingModule = moduleFactory.create({
  parseError: parseUnknownErrorIntoBaseError,
});
